import { ChangeDetectionStrategy, Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import {
  ContactFormMapInterface,
} from "../../../@core/models/site-data.model";
import { isPlatformBrowser } from "@angular/common";

declare let L: any;
@Component({
  selector: "app-map",
  templateUrl: "./map.component.html",
  styleUrls: ["./map.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialMapComponent implements OnInit {
  position: number = 0;
  data: ContactFormMapInterface;
  backgroundColor: string;
  lat: number;
  lng: number;
  address: string;
  buttonText: string;
  mapTimer: any;
  buttonLink: string;
  email: string;
  phone: string;
  timetable: string;

  constructor(@Inject(PLATFORM_ID) public platformId) { }

  ngOnInit() {
    this.backgroundColor = this.data.backgroundColor;
    this.lat = this.data.lat ? typeof this.data.lat == 'string' ? Number(this.data.lat.trim()) : Number(this.data.lat) : 40.7127281;
    this.lng = this.data.lng ? typeof this.data.lng == 'string' ? Number(this.data.lng.trim()) : Number(this.data.lng) : -74.0060152;
    this.buttonLink = this.data.buttonLink;
    this.buttonText = this.data.buttonText;
    this.address = this.data.address;
    this.email = this.data.email;
    this.phone = this.data.phone;
    this.timetable = this.data.timetable;
    const url = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
    if (!window.document.querySelector(`script[src='${url}']`)) {
      let script = window.document.createElement("script");
      script.src = url;
      window.document.body.appendChild(script);
      let link = window.document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
      window.document.body.appendChild(link);
      if (window.document.getElementById("map-" + this.position)) {
        if (isPlatformBrowser(this.platformId)) {
          setTimeout(this.LoadMap.bind(this), 2000);
        }
      } else {
        this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
      }
    } else {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
  }
  LoadLeaflet() {
    window.document.getElementById(
      "global-map-container-" + this.position
    ).innerHTML = "";
    window.document.getElementById(
      "global-map-container-" + this.position
    ).innerHTML = `<div class="mapcontainer" id="map-${this.position}"></div>`;
    if (window.document.getElementById("map-" + this.position)) {
      clearTimeout(this.mapTimer);
      window.document.getElementById("map-" + this.position).innerHTML =
        "<div  style='width: 100%; height: 100%;z-index: 0;' id='map-" +
        this.position +
        "'></div>";
      const url = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement("script");
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
        window.document.body.appendChild(link);
      }
      setTimeout(this.LoadMap.bind(this), 5000);
    }
    if (
      window.document.getElementById("map-" + this.position) &&
      this.lat &&
      this.lng
    ) {
      setTimeout(this.LoadMap.bind(this), 2000);
    } else {
      this.mapTimer = setTimeout(this.LoadLeaflet.bind(this), 500);
    }
  }
  LoadMap() {
    try {
      if (L) {
        let buttonOverlay = "";
        if (this.data.address) {
          buttonOverlay =
            buttonOverlay +
            `<div style="font-size:15px;font-weight: 500;margin-top: 20px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: #e91e63; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">location_on</i>${this.data.address}</div></div>`;
        }
        if (this.data.email) {
          buttonOverlay =
            buttonOverlay +
            `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> email </i>${this.data.email}</div></div>`;
        }
        if (this.data.phone) {
          buttonOverlay =
            buttonOverlay +
            `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;color: green; font-size: 17px ​!importan;" class="features-material-icons-small material-icons"> call </i>${this.data.phone}</div></div>`;
        }
        if (this.data.timetable) {
          buttonOverlay =
            buttonOverlay +
            `<div style="font-size:15px;font-weight: 500;margin-top: 10px;"><div style="font-size:14px;"><i style="vertical-align: sub;blue; font-size: 17px ​!importan;" class="features-material-icons-small material-icons">  schedule  </i>${this.data.timetable}</div></div>`;
        }
        if (this.lat && this.lng) {
          var mymap = L.map("map-" + this.position).setView(
            [this.lat, this.lng],
            14
          );
          var marker = L.marker([this.lat, this.lng])
            .addTo(mymap)
            .bindPopup(
              '<div style="font-size:15px;font-weight: 500;margin-top: 20px;"><i class="far fa-map"></i></div>' +
              buttonOverlay
            )
            .openPopup();
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            minZoom: 5,
            maxZoom: 18,
            attribution:
              '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
          }).addTo(mymap);
        }
      } else {
        const url = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
        if (!window.document.querySelector(`script[src='${url}']`)) {
          let script = window.document.createElement("script");
          script.src = url;
          window.document.body.appendChild(script);
          let link = window.document.createElement("link");
          link.rel = "stylesheet";
          link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
          window.document.body.appendChild(link);
        }
        setTimeout(this.LoadMap.bind(this), 5000);
      }
    } catch (err) {
      const url = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.js";
      if (!window.document.querySelector(`script[src='${url}']`)) {
        let script = window.document.createElement("script");
        script.src = url;
        window.document.body.appendChild(script);
        let link = window.document.createElement("link");
        link.rel = "stylesheet";
        link.href = "https://unpkg.com/leaflet@1.7.1/dist/leaflet.css";
        window.document.body.appendChild(link);
      }
      setTimeout(this.LoadMap.bind(this), 2000);
    }
  }
}
